class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resultsContainer = this.querySelector('[data-predictive-search]');
    this.isOpen = false;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    // Close on escape key
    this.input.addEventListener('keydown', (event) => {
      if (event.code === 'Escape') this.close();
    });
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    // Fetch product suggestions from Shopify's JSON API
    fetch(window.Shopify.routes.root + `search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.statusText);
          this.close();
          throw error;
        }
        return response.json();
      })
      .then((text) => {
        const results = text.resources.results.products;
        if (results.length > 0) {
          this.renderResults(results);
        } else {
          this.resultsContainer.innerHTML = '<p style="padding:15px; text-align:center; color:#666;">No results found.</p>';
          this.open();
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  renderResults(products) {
    // Build HTML for each product
    const html = products.map((product) => {
      // Handle image (use placeholder if missing)
      const image = product.image ? `<img src="${product.image}" alt="${product.title}" width="50" height="50">` : '';
      
      return `
        <a href="${product.url}" class="predictive-search-item">
          <div class="predictive-search-image">
            ${image}
          </div>
          <div class="predictive-search-content">
            <span class="predictive-search-title">${product.title}</span>
            <span class="predictive-search-price">${product.price}</span>
          </div>
        </a>
      `;
    }).join('');

    this.resultsContainer.innerHTML = `<div class="predictive-search-list">${html}</div>`;
    this.open();
  }

  open() {
    this.resultsContainer.style.display = 'block';
    this.isOpen = true;
  }

  close() {
    this.resultsContainer.style.display = 'none';
    this.resultsContainer.innerHTML = '';
    this.isOpen = false;
  }
}

customElements.define('predictive-search', PredictiveSearch);